<script setup lang="ts">
defineProps<{ progress: number }>();
</script>
<template>
  <div class="max-w-full flex px-3 rounded-lg pt-2 box-content h-[4px]">
    <progress
      id="progressBar"
      :value="progress"
      :class="[
        'rounded-lg',
        'w-full',
        'h-full',
        'bg-base',
        '[&::-webkit-progress-value]:h-[5px]',
        '[&::-webkit-progress-value]:transition-all',
        '[&::-webkit-progress-value]:duration-1000',
        '[&::-webkit-progress-value]:ease-out',
        '[&::-webkit-progress-value]:rounded-lg',
        '[&::-webkit-progress-value]:bg-primary-blue-gradient',
        '[&::-webkit-progress-bar]:rounded-lg',
        '[&::-webkit-progress-bar]:bg-base',
      ]"
    />
  </div>
</template>
